import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getDrillDictTreeApi, getDrillCalendarApi, getDrillByDateApi, postDrillDataApi } from 'api'
import { BoundarySlice } from 'redux/reducers'

const initialState = {
    calendarInfo: null, // 被点击的日历信息
    calendarData: null, // 日历上当前范围内显示的总结填写信息
    dictData: null, // 数据字典
    DrillData: null, // 回显数据
    locationName: '', // location 名称
    locationId: '', // location id
    id: '',
    save: false,
}

/* 获取日历上的数据 */
export const getDrillDataCalendarAction = createAsyncThunk('DrillDataSlice/getDrillDataCalendarAction', async (params, thunkAPI) => {
    try {
        const result = await getDrillCalendarApi(params)
        return result?.data?.data
    } catch (error) {
        thunkAPI.dispatch(BoundarySlice.actions.addError(error))
    }
})

/* 获取数据字典*/
export const getDrillDataDictDataAction = createAsyncThunk('DrillDataSlice/getDrillDataDictDataAction', async (dictType, thunkAPI) => {
    const nameDataDict = getDrillDictTreeApi(dictType[0])
    return Promise.all([nameDataDict])
        .then(dictData => dictData)
        .catch(error => thunkAPI.dispatch(BoundarySlice.actions.addError(error)))
})

/* 获取数据 */
export const getDrillDataDataAction = createAsyncThunk('DrillDataSlice/getDrillDataDataAction', async (listDataParams, thunkAPI) => {
    try {
        const data = await getDrillByDateApi(listDataParams)
        return data?.data
    } catch (error) {
        thunkAPI.dispatch(BoundarySlice.actions.addError(error))
    }
})

/* 保存数据 */
export const postDrillDataDataAction = createAsyncThunk('DrillDataSlice/postDrillDataDataAction', async (mmoObj, { dispatch }) => {
    try {
        await postDrillDataApi(mmoObj)
        return true // 已保存状态
    } catch (error) {
        dispatch(BoundarySlice.actions.addError(error))
    }
})

/* 通过日期获取 id */
export const getDrillByDateAction = createAsyncThunk('DrillSlice/getDrillByDateAction', async (listDataParams, thunkAPI) => {
    try {
        const commentData = await getDrillByDateApi(listDataParams) // 通过日期查询 id
        return commentData?.data?.data?.id
    } catch (error) {
        thunkAPI.dispatch(BoundarySlice.actions.addError(error))
    }
}
)

export const DrillSlice = createSlice({
    name: 'DrillSlice',
    initialState,
    reducers: {
        /* 日历点击信息 */
        addCalendarInfo: (state, action) => {
            state.calendarInfo = action.payload
        },
        /* 清空日历与详情页信息 */
        clearListData: state => {
            state.DrillData = null
            state.calendarData = null
            state.save = false
        },
    },
    extraReducers: {
        /* 获取日历上的数据 */
        [getDrillDataCalendarAction.fulfilled.type]: (state, action) => {
            state.calendarData = action.payload
        },

        /* 处理数据字典 */
        [getDrillDataDictDataAction.fulfilled.type]: (state, action) => {
            state.dictData = action.payload
        },

        // /* 通过日期，获取 回显数据 */
        [getDrillDataDataAction.fulfilled.type]: (state, action) => {
            state.DrillData = action.payload
            state.id = action.payload?.data?.id
        },

        /* 通过日期，获取 id */
        [getDrillByDateAction.fulfilled.type]: (state, action) => {
            state.id = action.payload
        },
    },
})
